import { jsxs, jsx } from "react/jsx-runtime";
const IconChecklistSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M13 9h7a1 1 0 1 0 0-2h-7a1 1 0 1 0 0 2Zm7 6h-7a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2ZM9.293 5.293 6 8.586 4.707 7.293a1 1 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414Zm0 8L6 16.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l2 2a.997.997 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414Z" })
    ]
  }
);
export {
  IconChecklistSvg
};
